/**
 * Chrome for unauthenticated document pages (accept-proposal now, sign-contract
 * in 4b-4). Mirrors Login.jsx: full-height app background, centered card.
 * `branding` = { divisionName, logoUrl, accentColor } or null while loading.
 */
export function PublicDocumentLayout({ branding, children }) {
  const name = branding?.divisionName || "Bayshore Marketing Group";
  return (
    <div className="min-h-screen bg-app-bg px-4 py-8">
      <div className="w-full max-w-2xl mx-auto">
        <div className="flex items-center justify-center gap-2 mb-6">
          {branding?.logoUrl ? (
            <img src={branding.logoUrl} alt={name} className="h-9 max-w-[200px] object-contain" />
          ) : (
            <>
              <div className="w-8 h-8 rounded bg-accent flex items-center justify-center text-white text-[14px] font-bold">{name.charAt(0)}</div>
              <span className="text-[18px] font-semibold text-text-primary">{name}</span>
            </>
          )}
        </div>
        <div className="bg-surface border border-border-default rounded-card p-6 sm:p-8">{children}</div>
        <p className="mt-4 text-center text-[11px] text-text-muted">Powered by Prism · Bayshore Marketing Group</p>
      </div>
    </div>
  );
}

/** Centered message block for the invalid / expired / accepted / success states. */
export function PublicMessage({ title, children }) {
  return (
    <div className="text-center py-6">
      <h1 className="text-[16px] font-semibold text-text-primary mb-2">{title}</h1>
      <p className="text-[13px] text-text-secondary leading-relaxed">{children}</p>
    </div>
  );
}
